/**
 * Date formatting utilities for URL parameters
 */

/**
 * Format a Date object to MM-DD-YYYY string for URL
 * @param {Date|string|null} date - Date to format
 * @returns {string|null} - Formatted date string or null
 */
export const formatDateForUrl = (date) => {
  if (!date) return null;
  const d = date instanceof Date ? date : new Date(date);
  if (isNaN(d.getTime())) return null;
  const month = (d.getMonth() + 1).toString().padStart(2, "0");
  const day = d.getDate().toString().padStart(2, "0");
  const year = d.getFullYear();
  return `${month}-${day}-${year}`;
};

/**
 * Parse MM-DD-YYYY string from URL to Date object
 * @param {string|null} dateStr - Date string in MM-DD-YYYY format
 * @returns {Date|null} - Parsed Date object or null
 */
export const parseDateFromUrl = (dateStr) => {
  if (!dateStr) return null;
  const parts = dateStr.split("-");
  if (parts.length !== 3) return null;
  const [month, day, year] = parts.map(Number);
  if (isNaN(month) || isNaN(day) || isNaN(year)) return null;
  const date = new Date(year, month - 1, day);
  if (isNaN(date.getTime())) return null;
  return date;
};
